// extracted by mini-css-extract-plugin
module.exports = {"Category-item__child":"server-category-item_Category-item__child__IBwrj"};